import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ViewOnlyProps } from '@components/Checkout/steps/CustomerInfoStep/CustomerInfoStep.types';

const FALLBACK = '—';

const formatBillingAddress = (values: NonNullable<ViewOnlyProps['savedValues']>, serviceAddress: string): string => {
  if (values.useSameAddress) return serviceAddress;
  const street = values.billingUnit ? `${values.billingStreet}, ${values.billingUnit}` : values.billingStreet;
  return [street, values.billingCity, values.billingProvince, values.billingPostalCode].filter(Boolean).join(', ');
};

const formatHowDidYouHear = (values: NonNullable<ViewOnlyProps['savedValues']>): string => {
  if (values.howDidYouHearAboutUs === 'Other') return values.howDidYouHearAboutUsOther || FALLBACK;
  return values.howDidYouHearAboutUs || FALLBACK;
};

const formatBillDelivery = (delivery: string | undefined): string =>
  delivery === 'email' ? 'Email (Paperless E-bill)' : 'Postal Mail';

export const ViewOnly = ({ metadata, serviceAddress, savedValues }: ViewOnlyProps) => {
  const titleLabel = metadata?.titles?.find((t) => String(t.titleId) === savedValues?.titleId)?.name ?? FALLBACK;
  const fullName = savedValues
    ? [savedValues.firstName, savedValues.middleName, savedValues.lastName].filter(Boolean).join(' ')
    : '';

  return (
    <Box>
      <Paper variant="checkoutReadOnlyGrid">
        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">Title</Typography>
          <Typography className="CheckoutReadOnlyValue">{titleLabel}</Typography>
        </Stack>
        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">Name</Typography>
          <Typography className="CheckoutReadOnlyValue">{fullName}</Typography>
        </Stack>
        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">Date of Birth</Typography>
          <Typography className="CheckoutReadOnlyValue">{savedValues?.dateOfBirth || FALLBACK}</Typography>
        </Stack>

        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">How Did You Hear about Us?</Typography>
          <Typography className="CheckoutReadOnlyValue">
            {savedValues ? formatHowDidYouHear(savedValues) : FALLBACK}
          </Typography>
        </Stack>
        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">Phone Number</Typography>
          <Typography className="CheckoutReadOnlyValue">{savedValues?.primaryPhoneNumber || FALLBACK}</Typography>
        </Stack>
        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">Email</Typography>
          <Typography className="CheckoutReadOnlyValue">{savedValues?.email || FALLBACK}</Typography>
        </Stack>

        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">Password</Typography>
          <Typography className="CheckoutReadOnlyValue">••••••••••</Typography>
        </Stack>
        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">Service Address</Typography>
          <Typography className="CheckoutReadOnlyValue">{serviceAddress}</Typography>
        </Stack>
        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">Billing Address</Typography>
          <Typography className="CheckoutReadOnlyValue">
            {savedValues ? formatBillingAddress(savedValues, serviceAddress) : FALLBACK}
          </Typography>
        </Stack>
        <Stack spacing={0.5} useFlexGap>
          <Typography className="CheckoutReadOnlyLabel">Bill Delivery</Typography>
          <Typography className="CheckoutReadOnlyValue">{formatBillDelivery(savedValues?.billDelivery)}</Typography>
        </Stack>
      </Paper>
    </Box>
  );
};
